import {Component, Input, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {UserService} from '../../../../services/user.service';

@Component({
  selector: 'platform-reach-placeholder',
  templateUrl: './platform-reach-placeholder.component.html',
  styleUrls: ['./platform-reach-placeholder.component.scss']
})
export class PlatformReachPlaceholderComponent implements OnInit {

  public defaultChartItems = [
    {id: 1, name: 'Blogs'},
    {id: 2, name: 'Instagram'},
    {id: 3, name: 'Pinterest'},
    {id: 4, name: 'Youtube'},
  ];

  @Input() fallbackTitle: string;
  @Input() fallbackMessage: string;
  @Input() chartItems: Array<object>;


  constructor(private translate: TranslateService, private userService: UserService) {
  }

  ngOnInit() {
    if (!this.fallbackTitle) {
      this.fallbackTitle = this.userService.isFreeUser() && !this.userService.isAdmin
        ? this.translate.instant('common.invalid_action_by_levels_warning.fallback_title')
        : this.translate.instant('measure.noDataTitle');
    }

    if (!this.fallbackMessage) {
      this.fallbackMessage = this.userService.isFreeUser() && !this.userService.isAdmin
        ? this.translate.instant('common.invalid_action_by_levels_warning.fallback_message')
        : this.translate.instant('measure.noData');
    }

    this.chartItems = this.chartItems && this.chartItems.length > 0 ? this.chartItems : this.defaultChartItems;
  }

}



// WEBPACK FOOTER //
// ./src/app/main/influencer/influencer-insight/platform-reach-placeholder/platform-reach-placeholder.component.ts